import { clearRemunerationSummary } from 'modules/remunerationSummary';
import { RESULT_CONTAINERS_LIST } from 'shared/enums';

export const clearNavigationActions = {
  [RESULT_CONTAINERS_LIST.EPS]: clearRemunerationSummary,
  [RESULT_CONTAINERS_LIST.SERVICE_CATEGORY]: clearRemunerationSummary,
};
